module.exports = __webpack_public_path__ + "img/ANTENNA RADIO 2 RED.372da88.svg";